export enum ContentTypes {
  ARTICLES_AND_PUBLICATION = "Articles and Publication",
  VIDEO = "Videos",
  DATA_VISUALISATIONS = "Data Visualizations",
}
